export default __webpack_public_path__ + "static/media/schedule.83b27a6b.png";